export default {
    meta: {
        title: '踩点记录-地址选择页'
    }
};
